import React from "react"
import styled from "styled-components"

const TopHeroModal = ({ title, subtitle }) => {
  return (
    <Wrapper>
      
        <div className="page-center">
          <div className="text">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      
    </Wrapper>
  )
}

const Wrapper = styled.section`
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .page-center {
    width: 90vw;
    margin: 0 auto;
    h1 {
      font-size: 32px;
      line-height: 50px;
      text-align: center;
      @media screen and (min-width: 1025px) {
        font-size: 64px;
        line-height: 120%;
      }
    }
    p {
        text-align: center;
        font-size: 16px;
        line-height: 190%;
        @media screen and (min-width: 1025px) {
            font-size: 25px;
            margin-top: 40px;
        }
    }
  }

`
export default TopHeroModal
